import styled, { keyframes } from 'styled-components';
import { FaChevronDown } from 'react-icons/fa';

import flex from './../../styles/flex';
import WindowShell from './../Window';

import { applyTheme, getThemeColor, hover, when, whenNot } from './../../styles/mixins';
import { breakpoints, isHorizontal, smaller, smallerHeight } from './../../styles/responsive';
import { ELEMENTS, zIndexFor } from './../../styles/zindex';

//components
import Icon from './../../icons/Icon';

const cloudDirectional = keyframes`
  0% {
    transform: translateX(0px) translateY(0px) scale(var(--cloud-scale, 1));
  }
  100% {
    transform: translateX(var(--cloud-drift-x, 26px)) translateY(var(--cloud-drift-y, -8px)) scale(var(--cloud-scale, 1));
  }
`;

const cloudSway = keyframes`
  0% { margin-top: 0px; }
  50% { margin-top: var(--cloud-sway-y, 8px); }
  100% { margin-top: 0px; }
`;

const hintBounce = keyframes`
  0%, 100% { transform: translateY(0); opacity: 0.7; }
  50% { transform: translateY(8px); opacity: 1; }
`;

export const Text = styled.div(getThemeColor('text'));

export const SlideStyle= { 
  display: 'flex', 
  width: '100%', 
  justifyContent: 'center',
  alignItems: 'center' 
}

export const Satya = styled.div({
  display:'flex',
  ...flex.centerVertical,
  ...flex.centerHorizontal,
  // ...zIndexFor(ELEMENTS.CONTENT),
  //marginTop: 'auto',
  maxWidth: 1100,
  //padding: "10px",
  //marginBottom: 'auto',
  [isHorizontal]: {
    flexDirection: 'column',
    ...flex.centerVertical,
    width: '100%',
    maxWidth: 'min(560px, 94vw)'
  }
});

export const ContentView = styled.div({
  //display: 'flex',
  //justifyContent: 'center',
  //alignItems: 'center'
})

export const MainText = styled.div({
  ...flex.centerHorizontal,
  // ...zIndexFor(ELEMENTS.CONTENT),
  marginTop: 0,
  display: 'flex',
  //maxWidth: 1200,
  padding: '10px',
  marginBottom: 0,
  [smaller(1520)]: {
    maxWidth: 1200
  },
  [smaller(1150)]: {
    maxWidth: 900
  },
  [smaller(980)]: {
    maxWidth: 700
  },
  // [smaller(breakpoints.medium)]: {
  //   padding: '200px'
  // },
  [isHorizontal]: {
    flexDirection: 'column',
    ...flex.centerVertical,
    width: '100%',
    maxWidth: 'min(560px, 94vw)'
  }
});


export const CloudsLayer = styled.div({
  position: 'absolute',
  inset: 0,
  pointerEvents: 'none',
  overflow: 'hidden',
  ...zIndexFor(ELEMENTS.MAIN_SECTION)
});

export const Cloud = styled.div`
  position: absolute;
  top: ${({ top }) => top};
  left: ${({ left }) => left};
  width: ${({ width = 170 }) => width}px;
  height: ${({ height = 70 }) => height}px;
  opacity: ${({ opacity = 0.22 }) => opacity};
  transform: scale(${({ scale = 1 }) => scale});
  transform-origin: top left;
  border-radius: ${({ variant = 'cumulus' }) => (variant === 'cirrus' ? '34% 66% 41% 59% / 62% 38% 66% 34%' : variant === 'stratus' ? '28% 72% 34% 66% / 50% 50% 58% 42%' : variant === 'stormEdge' ? '64% 36% 58% 42% / 40% 60% 34% 66%' : '52% 48% 60% 40% / 58% 42% 52% 48%')};
  filter: blur(${({ blur = 0.6 }) => blur}px);
  background: ${({ variant = 'cumulus' }) =>
    variant === 'cirrus'
      ? 'radial-gradient(44% 34% at 22% 56%, rgba(197,228,250,0.32) 0 66%, rgba(197,228,250,0) 100%), radial-gradient(48% 30% at 54% 42%, rgba(203,232,252,0.28) 0 68%, rgba(203,232,252,0) 100%), radial-gradient(40% 26% at 80% 58%, rgba(192,224,247,0.24) 0 62%, rgba(192,224,247,0) 100%)'
      : variant === 'stratus'
      ? 'radial-gradient(42% 30% at 18% 62%, rgba(196,226,248,0.34) 0 68%, rgba(196,226,248,0) 100%), radial-gradient(46% 34% at 50% 58%, rgba(205,233,252,0.36) 0 70%, rgba(205,233,252,0) 100%), radial-gradient(42% 30% at 82% 62%, rgba(196,226,248,0.34) 0 68%, rgba(196,226,248,0) 100%)'
      : variant === 'stormEdge'
      ? 'radial-gradient(46% 36% at 24% 58%, rgba(183,212,236,0.38) 0 70%, rgba(183,212,236,0) 100%), radial-gradient(52% 40% at 56% 46%, rgba(195,221,243,0.42) 0 72%, rgba(195,221,243,0) 100%), radial-gradient(40% 34% at 84% 62%, rgba(175,206,232,0.34) 0 68%, rgba(175,206,232,0) 100%)'
      : 'radial-gradient(44% 38% at 26% 60%, rgba(198,228,250,0.38) 0 70%, rgba(198,228,250,0) 100%), radial-gradient(50% 42% at 52% 46%, rgba(208,235,253,0.4) 0 72%, rgba(208,235,253,0) 100%), radial-gradient(42% 36% at 80% 60%, rgba(194,225,248,0.34) 0 68%, rgba(194,225,248,0) 100%)'};
  --cloud-scale: ${({ scale = 1 }) => scale};
  --cloud-drift-x: ${({ driftX, drift = 18 }) => (typeof driftX === 'number' ? `${driftX}px` : (driftX || `${drift}px`))};
  --cloud-drift-y: ${({ driftY, bob = 8 }) => (typeof driftY === 'number' ? `${driftY}px` : (driftY || `${-bob}px`))};
  --cloud-sway-y: ${({ swayY = 8 }) => swayY}px;
  animation: ${cloudDirectional} ${({ duration = 28 }) => duration}s linear ${({ delay = 0 }) => delay}s infinite,
    ${cloudSway} ${({ swayDuration = 6 }) => swayDuration}s ease-in-out ${({ delay = 0 }) => delay}s infinite;

  &::before {
    content: '';
    position: absolute;
    inset: ${({ variant = 'cumulus' }) => (variant === 'cirrus' ? '20% 12% 28% 12%' : variant === 'stratus' ? '22% 10% 26% 10%' : variant === 'stormEdge' ? '16% 8% 26% 8%' : '18% 8% 24% 8%')};
    border-radius: ${({ variant = 'cumulus' }) => (variant === 'cirrus' ? '34% 66% 41% 59% / 62% 38% 66% 34%' : variant === 'stratus' ? '28% 72% 34% 66% / 50% 50% 58% 42%' : variant === 'stormEdge' ? '64% 36% 58% 42% / 40% 60% 34% 66%' : '52% 48% 60% 40% / 58% 42% 52% 48%')};
    background: radial-gradient(ellipse at center, rgba(210, 236, 255, 0.34), rgba(210, 236, 255, 0));
    filter: blur(5px);
    pointer-events: none;
  }

  &::after {
    content: '';
    position: absolute;
    left: ${({ variant = 'cumulus' }) => (variant === 'cirrus' ? '22%' : variant === 'stratus' ? '14%' : '18%')};
    right: ${({ variant = 'cumulus' }) => (variant === 'cirrus' ? '22%' : variant === 'stratus' ? '14%' : '18%')};
    bottom: -20%;
    height: ${({ variant = 'cumulus' }) => (variant === 'cirrus' ? '30%' : variant === 'stratus' ? '34%' : '38%')};
    border-radius: ${({ variant = 'cumulus' }) => (variant === 'cirrus' ? '34% 66% 41% 59% / 62% 38% 66% 34%' : variant === 'stratus' ? '28% 72% 34% 66% / 50% 50% 58% 42%' : variant === 'stormEdge' ? '64% 36% 58% 42% / 40% 60% 34% 66%' : '52% 48% 60% 40% / 58% 42% 52% 48%')};
    background: radial-gradient(ellipse at center, rgba(70, 114, 156, 0.22), rgba(70, 114, 156, 0));
    filter: blur(8px);
    pointer-events: none;
  }
`;



export const Home = styled.div({
  ...flex.vertical,
  minHeight: '100vh',
  height: '100dvh',
  width: '100%',
  overflow: 'hidden'
});

export const Subtitle = styled(Text)({
  fontSize: 'clamp(20px, 1.1vw + 14px, 25px)',
  fontWeight: 300,
  lineHeight: 'clamp(30px, 1.2vw + 18px, 40px)',
  width: '100%',
  [smaller(950)]: {
    fontSize: 'clamp(18px, 2.2vw, 23px)'
  },
  [smaller(breakpoints.medium)]: {
    fontSize: 'clamp(18px, 2.6vw, 22px)',
    padding: '0'
  },
  [isHorizontal]: {
    fontSize: 'clamp(17px, 3vw, 20px)'
    //lineHeight: '30px'
  }
});

export const Window = styled(WindowShell)(
  {
    transition: 'all 250ms linear',
    [isHorizontal]: {
      margin: 'auto',
      width: '100%'
    }
  },
  when('hovering', {
    transform: 'scale(1.03)'
    //boxShadow: '0 20px 25px 12px rgba(0, 0, 0, 0.22)'
  })
);

export const Title = styled(Text)({
  fontWeight: 500,
  fontSize: 55,
  lineHeight: '50px',
  transition: 'all 250ms linear',
  cursor: 'default'
});

export const MainSection = styled.div({
  //position: 'relative',
  //...flex.vertical,
  //...flex.centerHorizontal,
  //width: '100%',
  //minHeight: '100vh',
  //flex: 1,
  //...zIndexFor(ELEMENTS.MAIN_SECTION)
});

export const Padding = styled.div({
  padding: '30px 90px',
  [smaller(breakpoints.large)]: {
    padding: '30px 50px'
  },
  [smaller(breakpoints.medium)]: {
    padding: '20px 40px'
  },
  [isHorizontal]: {
    padding: '30px 15px'
  }
});

export const Footer = styled.div(
  {
    position: 'relative',
    ...zIndexFor(ELEMENTS.FOOTER),
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    backdropFilter: 'blur(18px) saturate(140%)',
    WebkitBackdropFilter: 'blur(18px) saturate(140%)',
    borderTop: '1px solid rgba(255,255,255,0.14)',
    boxShadow: '0 -8px 24px rgba(0,0,0,0.28)',
    transition: 'all 100ms linear',
    borderTopLeftRadius: 5,
    borderTopRightRadius: 5,
    padding: '8px 14px',
    overflow: 'hidden',
    left: 'auto',
    right: 'auto',
    bottom: 'auto',
    margin: 0,
    opacity: 0
  },
  ({ theme, compact }) => ({
    ...(compact && {
      padding: '8px 14px',
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0
    }),
    [smaller(750)]: {
      position: 'relative',
      ...zIndexFor(ELEMENTS.FOOTER),
      width: '100%',
      backgroundColor: theme.name === 'dark' ? 'rgba(0, 0, 0, 0.7)' : 'rgba(242, 242, 242, 0.7)',
      backdropFilter: 'blur(18px) saturate(140%)',
      WebkitBackdropFilter: 'blur(18px) saturate(140%)',
      borderTop: theme.name === 'dark' ? '1px solid rgba(255,255,255,0.14)' : '1px solid rgba(198,221,244,0.7)' 
    },
    [smallerHeight(715)]: {
      position: 'relative',
      ...zIndexFor(ELEMENTS.FOOTER),
      width: '100%'
    }
  })
);

export const Links = styled.div({
  ...flex.horizontal,
  ...flex.centerHorizontal,
  ...flex.centerVertical
});

export const Links2 = styled.div({
  ...flex.horizontal,
  ...flex.centerHorizontal,
  marginBottom: "0.2rem"
});

export const Link = styled.a(
  {
    textDecoration: 'none',
    borderBottom: '1px solid transparent',
    transition: 'all 100ms linear',
    marginRight: 20,
    '&:last-of-type': {
      margin: 0
    },
    fontSize: 13,
    ...hover({
      borderBottom: '1px solid white'
    })
  },
  getThemeColor('text')
);

export const Social = styled.button(
  {
    ...flex.horizontal,
    ...flex.centerHorizontal,
    userSelect: 'none',
    border: 'none',
    // fontSize: 18,
    // borderRadius: 4,
    // maxWidth: 20,
    // padding: 15,
    //width: '100%',
    minHeight: 36,
    minWidth: 36,
    borderRadius: 8,
    transition: 'all 150ms linear',
    boxShadow: '0px 1px 1px rgba(0, 0, 0, 0.0)'
  },
  applyTheme('socialicon'),
  when('disabled', {
    opacity: 0.5,
    cursor: 'not-allowed'
  }),
  ({ theme }) => ({
    ...(!theme.disabled && {
      ...hover({
        background: theme.button.backgroundHover,
        borderRadius: 10
      })
    })
  })
);

export const SocialIcon = styled(Icon)(
  {
    //marginRight: 15,
    // marginBottom: 8,
    width: 22,
    height: 'auto',
    position: 'relative',
    top: -1,
    opacity: 0.7
  },
  getThemeColor('text', 'fill')
);

export const Content = styled(Padding)({
  ...zIndexFor(ELEMENTS.CONTENT),
  color: 'white',
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  flex: 1,
  minHeight: 0,
  overflowY: 'auto',
  overflowX: 'hidden',
  marginTop: 0,
  marginBottom: 0,
  [smaller(breakpoints.md)]: {
    justifyContent: 'center',
    alignItems: 'stretch',
    paddingTop: 0
  },
  '@media screen and (max-width: 768px) and (min-width: 560px)': {
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'stretch',
    paddingTop: 0
  },
  [smaller(560)]: {
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'stretch',
    paddingTop: 52
  },
  [smallerHeight(700)]: {
    justifyContent: 'flex-start',
    paddingTop: 56
  }
});

export const TextContent = styled.div(
  {
    ...flex.vertical,
    [isHorizontal]: {
      ...flex.centerVertical,
      textAlign: 'center'
    }
  },
  whenNot('isAnimationDone', {
    pointerEvents: 'none'
  })
);


export const ScrollHint = styled.div`
  position: sticky;
  bottom: 2px;
  margin-top: auto;
  margin-bottom: -2px;
  align-self: center;
  width: 40px;
  height: 40px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(180deg, rgba(18, 35, 58, 0.72), rgba(8, 20, 36, 0.58));
  border: 1px solid rgba(170, 220, 255, 0.65);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.28), 0 0 0 1px rgba(159, 214, 255, 0.2) inset;
  color: #cfeaff;
  pointer-events: none;
  z-index: 5;
  animation: ${hintBounce} 1.6s ease-in-out infinite;

  ${smaller(560)} {
    bottom: 2px;
  }
`;

export const ScrollHintIcon = styled(FaChevronDown)`
  width: 16px;
  height: 16px;
  opacity: 0.95;
`;


export const CopyrightText = styled.p({
  color: 'white', 
  fontSize: 'clamp(12px, 0.35vw + 10px, 15px)',
  padding: 0, 
  margin: 0, 
  textAlign: 'center'
})
